import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import { submitSiteDelete } from "./../../utils/commonComponent/delete";
import { fetchQuery } from "./../../utils/commonComponent/fetched";
import ListSearchSection from "../../utils/commonComponent/Custom/ListSearchSection";
import ListView from "../../utils/commonComponent/Custom/listView";
import { getPermissions } from "../rbac/hasAccess";
import { userTypes } from "../../utils/commonComponent/userConstant";

const headers = ["id", "employeeName", "userName", "password", "type"];

const fields = [{ value: "userName", label: "User Name" },
{ value: "employeeName", label: "Employee Name" }
];

const UserMasterList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/master/editUser/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("userMaster", row.id);

  const [userList, setUserList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "employeeName");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
   // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));  


  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
  };

  const getWhereClause = () => {
    const colMap = {
      userName: "userName",
      employeeName: "e.name",
      location: "location",
    };

    const colName = colMap[searchBy];
    const key = searchKey.trim().toLowerCase();

    let whereConditions = ["um.status = 1"];

    if (colName && key) {
      whereConditions.push(`LOWER(${colName}) LIKE '%${key}%'`);
    }

    return whereConditions.length
      ? `WHERE ${whereConditions.join(" AND ")}`
      : "";
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();

    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)
        }`;
    }

    return `SELECT um.*, e.name AS employeeName FROM userMaster um LEFT JOIN employees e ON e.id = um.employeeId ${whereClause} ORDER BY um.id DESC ${paginationSettings};`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();

    return `SELECT COUNT(DISTINCT um.id) AS totalRows FROM userMaster um LEFT JOIN employees e ON e.id = um.employeeId ${whereClause};`;
  };

  const fetchData = async () => {
    try {
      const [userData, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);

      const mappedData = userData.map((user) => ({
        ...user,
        type: userTypes.find((t) => t.id == user.type)?.label || "",
      }));

      setUserList(mappedData);
      setTotalRows(countResult?.[0]?.totalRows || 0); // 👈 pagination count
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("employeeName");
    setSearchKey("");
     // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/master/editUser/0"
          label="Add User"
          icon={<AddIcon fontSize="small" />}
        />
      )}
      <ListSearchSection
        title="Search User"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      <ListView
        headers={headers}
        data={userList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
        }}
        showCheckbox={true}
        deleteTableName={"userMaster"}
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />
    </>
  );
};

export default UserMasterList;
